<div *ngIf="isLoading | async" class="lottie-loader-container dx-viewport">
  <div class="lottie-loader">
    <dx-load-panel
      shadingColor="rgba(0,0,0,0.5)"
      [visible]="true"
      [showIndicator]="true"
      [showPane]="true"
      [shading]="true"
      [hideOnOutsideClick]="false"
    >
    </dx-load-panel>
  </div>
</div>

<app-side-nav [routerPage]="'page'" *ngIf="authCheck"></app-side-nav>
<div id="page">
  <router-outlet></router-outlet>
</div>
